import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { NetworkState, NetworkStateType } from "expo-network";

interface State {
  networkState?: NetworkState;
  isSyncingLoading?: boolean;
}

const initialState: State = {
  networkState: undefined,
  isSyncingLoading: false,
};

export const networkSlice = createSlice({
  name: "network",
  initialState,
  reducers: {
    setNetworkState: (state, action: PayloadAction<NetworkState>) => {
      state.networkState = action.payload;
    },
    setIsSyncingLoading: (state, action: PayloadAction<boolean>) => {
      state.isSyncingLoading = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setNetworkState, setIsSyncingLoading } = networkSlice.actions;

export const selectIsOnline = (state: { network: State }) =>
  !!state.network.networkState?.isInternetReachable;
export default networkSlice.reducer;
